var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
var EditLinkForm = /** @class */ (function (_super) {
    __extends(EditLinkForm, _super);
    function EditLinkForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // config: Config = null;
        _this.title = '';
        _this.url = '';
        return _this;
    }
    EditLinkForm.prototype.mounted = function () {
        this.linkUpdated();
    };
    EditLinkForm.prototype.dbRef = function () {
        var linkId = this.linkId;
        return this.configName + "/" + linkId.section + "/links" + (linkId.sectionLinks ? '/' + linkId.sectionLinks : '') + (linkId.link ? '/' + linkId.link : '');
    };
    EditLinkForm.prototype.linkUpdated = function () {
        // if (!this.isAdd) {
        //   db.getLink(this.linkRef, link => {
        //     this.title = link.name;
        //     this.url = link.url;
        //   });
        // }
        if (this.linkId.link) {
            // db.getReference(this.dbRef()).once('value', snapshot => {
            //   this.title = snapshot.val().name;
            //   this.url = snapshot.val().url;
            // });
            var saved = this.config
                .child(this.linkId.section)
                .child('links')
                .child(this.linkId.sectionLinks)
                .child(this.linkId.link)
                .val();
            this.title = saved.name;
            this.url = saved.url;
            // .ref
            // .once('value', snapshot => {
            //   this.title = snapshot.val().name;
            //   this.url = snapshot.val().url;
            // })
        }
        else {
            this.title = '';
            this.url = '';
        }
    };
    EditLinkForm.prototype.cancel = function () {
        this.$emit('close');
    };
    EditLinkForm.prototype.saveLink = function () {
        var link = {
            url: this.url,
            name: this.title
        };
        // const reference = db.getReference(this.dbRef());
        if (this.linkId.link) {
            // reference.set(link);
            this.config.ref.child(this.linkId.section).child('links').child(this.linkId.sectionLinks).child(this.linkId.link).set(link);
        }
        else if (this.linkId.sectionLinks) {
            // reference.push().set(link);
            this.config.ref.child(this.linkId.section).child('links').child(this.linkId.sectionLinks).push(link);
        }
        else {
            // reference.push().push().set(link);
            this.config.ref.child(this.linkId.section).child('links').push().push(link);
        }
    };
    EditLinkForm.prototype.removeLink = function () {
        // db.getReference(this.dbRef()).remove();
        this.config
            .child(this.linkId.section)
            .child('links')
            .child(this.linkId.sectionLinks)
            .child(this.linkId.link)
            .ref.remove();
    };
    __decorate([
        Prop()
    ], EditLinkForm.prototype, "linkId", void 0);
    __decorate([
        Prop()
    ], EditLinkForm.prototype, "configName", void 0);
    __decorate([
        Prop(Function)
    ], EditLinkForm.prototype, "onClose", void 0);
    __decorate([
        Prop()
    ], EditLinkForm.prototype, "config", void 0);
    __decorate([
        Watch('linkId')
    ], EditLinkForm.prototype, "linkUpdated", null);
    __decorate([
        Emit('close')
    ], EditLinkForm.prototype, "saveLink", null);
    __decorate([
        Emit('close')
    ], EditLinkForm.prototype, "removeLink", null);
    EditLinkForm = __decorate([
        Component
    ], EditLinkForm);
    return EditLinkForm;
}(Vue));
export default EditLinkForm;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/EditLinkForm.vue
// module id = 190
// module chunks = 0